<template>
  <router-link
    :to="{ name: 'app-blogs', params: { blogId: blog.shortId } }"
  >
    <SidebarListItem
      :iconBackgroundColor="blog.isOwn ? 'blue' : null"
      :isActive="isActive"
    >
      <BaseIcon
        slot="icon"
        custom
        name="blogger"
      />
      <BaseIcon
        slot="corner"
        v-if="blog.isOwn"
        name="cog"
        @click.prevent="openEdit"
      />
      {{ blog.blogInfoDisplay.name }}
      <template slot="info">
        {{ blog.lastPostPublication | date('Pp') }}
      </template>
    </SidebarListItem>
  </router-link>
</template>

<script>
import SidebarListItem from '@/components/SidebarListItem'

export default {
  name: 'blog-list-item',
  components: {
    SidebarListItem
  },
  props: {
    activeBlogId: String,
    blog: Object
  },
  computed: {
    isActive () {
      if (!this.activeBlogId) return false
      return this.blog.shortId === this.activeBlogId
    }
  },
  methods: {
    openEdit () {
      this.$modal.show('edit-blog', {
        blog: this.blog
      })
    }
  }
}
</script>
